import React, { useState, useEffect } from "react";
import littleGuy from "../../TDD-Images/little-guy-alone_2.png";
import { capitalizeFirstLetter, generateGUID, getPackName, hasMultipleQuestionPacks, hasPremSub, parseQuestionQuery } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { companyOptions, JobDescription, SessionQuestion, track, type, User } from '@/utils/types';
import buddy from '../../TDD-Images/buddysteppingstone.png'
import { useAppContext } from "../appContext";
import { createSvgIcon } from '@mui/material/utils';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import { IconButton, TextField, Autocomplete, Chip, Stack, InputAdornment } from '@mui/material';
import UploadFile from './UploadFile';
import { DeviceHubOutlined, ElevatorOutlined, ErrorOutline, TaskAltOutlined } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { updateJobDescriptions, uploadUserResume } from '@/api';
import LoadingOverlay from './loadingOverlay';
import { BITESIZEDQuestions } from "@/utils/BiteSizedQuestions";

const DefaultRole = "Software Engineering";

const sampleJD = `Job Description
e.g. 
Microsoft is seeking a talented and motivated Software Engineer to join our dynamic team. As a Software Engineer, you will be responsible for designing, developing, and maintaining high-quality software solutions that drive our innovative products and services. You will work in a collaborative environment with cross-functional teams to create cutting-edge technology that impacts millions of users worldwide.

Responsibilities:

Design and Development: Design, develop, and implement software solutions that meet the needs of our customers and align with our strategic goals.
Code Quality: Write clean, maintainable, and efficient code following best practices and coding standards.
Collaboration: Collaborate with product managers, designers, and other engineers to gather requirements, define project scope, and deliver high-quality software on time.
Testing and Debugging: Perform unit testing, integration testing, and debugging to ensure the reliability and performance of the software.
Continuous Improvement: Participate in code reviews, provide constructive feedback, and continuously improve software development processes.
Documentation: Create and maintain technical documentation to support software development and deployment processes.
Innovation: Stay up-to-date with the latest industry trends and technologies, and apply them to improve existing products and develop new solutions.
Qualifications:

Education: Bachelor's or Master's degree in Computer Science, Engineering, or a related field.
Experience: 2+ years of experience in software development, preferably in a high-tech environment.
Technical Skills:
Proficiency in one or more programming languages such as C#, Java, Python, or JavaScript.
Experience with software development frameworks and tools such as .NET, Angular, React, or similar.
Knowledge of cloud platforms such as Azure, AWS, or Google Cloud.
Strong understanding of data structures, algorithms, and software design principles.
Problem-Solving: Excellent problem-solving skills and the ability to think critically and creatively.
Communication: Strong written and verbal communication skills, with the ability to clearly articulate technical concepts to non-technical stakeholders.
Team Player: Ability to work effectively both independently and as part of a team.
Preferred Qualifications:

Experience with DevOps practices and tools such as Docker, Kubernetes, Jenkins, or Git.
Familiarity with Agile development methodologies.
Experience with AI and machine learning technologies.
Contributions to open-source projects or participation in hackathons and coding competitions.`;


const DropdownWithInput: React.FC<{options: string[], handleChange: (x:string)=>void}> = ({options, handleChange}) => {
  const [value, setValue] = useState<string | null>(null);
  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value}
      onChange={(event, newValue) => {
        if (newValue === null) {
          setValue(null);
          handleChange("");
        } else {
          setValue(newValue);
          handleChange(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select existing or type a new name"
          variant="outlined"
          size="small"
          fullWidth
        />
      )}
    />
  );
};


const SearchBarWithIcon = ({options, editable, handleChange}: {options:string[], editable:boolean, handleChange: (x:string)=>void}) => {
  const [value, setValue] = useState<string | null>(null);

  return (
    <Autocomplete
      fullWidth
      options={options}
      sx={{textAlign:'left'}}
      freeSolo={editable}
      value={value}
      onChange={(event, newValue) => {
        if (newValue === null) {
          setValue(null);
          handleChange("");
        } else {
          setValue(newValue);
          handleChange(newValue);
        }
      }}
      renderInput={(params) => (
          <TextField
              {...params}
              label="Search"
              variant="outlined"
              size="small"
              fullWidth     
        />
      )}
    />
  );
};

let roles = [
  "Product Management", 
  "Software Engineering",
  "Data Scientist",
  "Business Analyst",
  "Cybersecurity Engineering",
  "Technical Program Management",
  "Web Development"
];


const LandingPage = () => {
  
  const {auth0, state, reducers, startFunc, stopAudio, resumeSession,navigateThenRun } =
    useAppContext();

  const getLastSavedSessionForRole = () => {
      if(state.role !== "" && state.profileUser?.savedSessions && Object.keys(state.profileUser?.savedSessions).length > 0)
      {
        const sessions = state.profileUser!.savedSessions;
        const keys = Object.keys(sessions).reverse(); //start from latest
        for(const key of keys){
          if(sessions[key].session[0].role === state.role){
            return sessions[key].session;
          }
        }
      }
      return [];
  }

  const navigate = useNavigate();
  const [parsedQuery, setParsedQuery] = useState<{ [key: string]: string }>({});
  const [lastSavedSessionForRole, setlastSavedSessionForRole] = useState<SessionQuestion[]>(getLastSavedSessionForRole());
  const [readOnly, setReadOnly] = useState(true);
  const [roleValue, setRoleValue] = useState<string>("");
  const [jobDescriptionQValue, setjobDescriptionQValue] = useState<JobDescription>({ title: "", description: "" });
  const [domainValue, setDomainValue] = useState<string>("");
  const [resume, setResume] = useState<{ text: string; file: string }>({
    text: "",
    file: "",
  });
  const jobDescriptions = state.profileUser ? (state.profileUser.JobDescriptions !== undefined ? state.profileUser.JobDescriptions : {}) : null;
  const JDOptions = jobDescriptions ? Object.keys(jobDescriptions) : [];

  const {
    setloading,
    setcurrentQuestion,
    setcurrScreen,
    setsession,
    setrole,
    setdomain,
    setcustomQ,
    setjobDescriptionQ,
    settype,
    settrack,
    setintQuestion,
    setqType,
    setretryPast,
    setrunSetQs,
    setprofileUser,
    setshowPaymentModal
  } = reducers;
  
  const updateResume = async () => {
    if(resume.text != state.profileUser?.resumename && resume.file !=  state.profileUser?.resumetext){
      const user2 = await uploadUserResume(resume.text, resume.file);
      if(user2){
        setprofileUser(user2);
      }
    }
  }

  const RoleBadges = () => (
    <>
      <div className="w-full mb-5 p-2">
        <Stack 
          direction="row" 
          spacing={1} 
          sx={{ 
            flexWrap: 'wrap',
            gap: 1,
            '& > *': {
              margin: '4px !important', // Override default spacing
            }
          }}
        >
          {roles.map((role) => (
            <Chip
              key={role}
              label={role}
              onClick={() => setrole(role.toLowerCase())}
              sx={{
                backgroundColor: '#FFF',
                border: '1px solid #D1D5DB',
                '&:hover': {
                  backgroundColor: '#F3F4F6',
                },
                fontSize: '0.875rem',
                fontWeight: 500,
                padding: '8px 4px',
                borderRadius: '16px',
                cursor: 'pointer',
                color: '#374151'
              }}
            />
          ))}
        </Stack>
      </div>
    </>
  );

  useEffect(() => {
    if(!state.role || state.role === ""){
      setrole(getTrack());
    }
    if (state.profileUser && state.profileUser.intakeForm["interestedRoles"]!= undefined)
    {
      const newroles: string[] = [];
      (state.profileUser.intakeForm["interestedRoles"] as string[]).forEach(x=>{
        let r = capitalizeFirstLetter(x);
        const ind = roles.indexOf(r);
        if(ind !== -1) {
          // Remove the role from the original array if it exists
          roles.splice(ind, 1);
        }
        newroles.push(r);
      });
      roles = newroles.concat(roles);
    }
  }, [state.profileUser]);

  useEffect(() => {
    if(resume.text !== "")
    updateResume();
  }, [resume.text]);

  useEffect(() => {
    if (state.role) {
      reducers.setoverlayComp(<LoadingOverlay loadingOverlay={true} />);
      setlastSavedSessionForRole(getLastSavedSessionForRole());
      setTimeout(() => {
        reducers.setoverlayComp(null);
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // This makes it scroll smoothly
        });
      }, 1200); // 2000 milliseconds = 2 seconds
    }
  }, [state.role]);

  useEffect(() => {
    if ((state.track === track.CUSTOM || state.track === track.BITESIZED ) && state.questions[state.track]) {
      let sessionId = generateGUID();
      setsession([{
        question: state.questions[state.track][0], 
        feedback: "", 
        actionsteps: "", 
        prompt: [],
        fullprompt: [], 
        samplesolution: "", 
        code: "",
        useWhiteboard: state.useWhiteboard, 
        codingLang: state.codingLang, 
        time: 0, 
        isHelpful: null,
        isHelpfulMessage:  null,
        role: state.role,
        feedbackDuration: 0,
        sessionId: sessionId,
        biteSizeOptions: state.track === track.BITESIZED ? BITESIZEDQuestions[state.type].options : undefined,
    }]);
      startFunc(0);
    }
    if(state.track === track.RESUMED)
    {
      startFunc(0, false);
    }
  }, [state.questions]);

  const NavigateForCustom = () => {
    settype(type.CUSTOM);
    settrack(track.CUSTOM);
    setcurrentQuestion(0); 
    setqType("choose question");
    setrunSetQs(true); 
  }

const NavigateToQBank = (type:string, track: string, domain:string = "")=>{
  settype(type);
  settrack(track);
  setdomain(domain);
  setqType('choose question');
  setcurrentQuestion(-1);
  setintQuestion(4);
  setrunSetQs(true);
  navigate('/track');
}

const NavigateToBiteSized = (type:string)=>{
  settype(type);
  settrack(track.BITESIZED);
  setqType('choose question');
  setcurrentQuestion(0);
  setqType("choose question");
  setrunSetQs(true); 
}

  // const setContinueInterviewTrack = () => {
  //   props.setRole(parsedQuery['role']);
  //   props.setType(parsedQuery['type']);
  //   props.settrack(parsedQuery['track']);
  //   if (parsedQuery['type'] !== 'custom') {
  //     props.setqType('random question');
  //     props.QuestionSelected(-1);
  //     props.setintQuestion(4);
  //   } else {
  //     setrunSetQs();
  //     props.setqType('choose question');
  //     props.setCustomQ(parsedQuery['specifics']);
  //     props.QuestionSelected(0);
  //     props.setintQuestion(3);
  //   }
  //   if (parsedQuery['type'] === 'domain') {
  //     props.setDomain(parsedQuery['specifics'])
  //   } else if (parsedQuery['type'] === 'jobDescriptionQ') {
  //     if (props.jobDescriptions) {
  //       props.setJobDescriptionQ({ title: parsedQuery['specifics'], description: props.jobDescriptions[parsedQuery['specifics']] })
  //     }
  //     else {
  //       console.log("No job descriptions found");
  //     }
  //   }

  //   props.next();
  //   navigate('/track');
  // }

  const handleJDTitle = (e: string | null) => {
    if (e !== null && e != "") {
        if (jobDescriptions && jobDescriptions.hasOwnProperty(e)) {
            setjobDescriptionQValue({ title: e, description: jobDescriptions[e] });
            setReadOnly(true);
        } else {
            setjobDescriptionQValue({ ...jobDescriptionQValue, title: e});
            setReadOnly(false);
        }
    } else {
        setjobDescriptionQValue({ description: "", title: "" });
    }
};

const resumeSesh = () =>{
  const savedsesh = state.profileUser?.savedSessions;
  if(savedsesh && Object.keys(savedsesh).length >0){
    const latest = getLatestSession(savedsesh);
    resumeSession(latest.session);
  }
}

const getLatestSession = (sessions: { [key: string]: { session: SessionQuestion[], timestamp: string } }) => {
  const latestSessionId = Object.keys(sessions).reduce((latest, current) => 
    !latest || new Date(sessions[current].timestamp) > new Date(sessions[latest].timestamp) ? current : latest
  );
  return { sessionId: latestSessionId, ...sessions[latestSessionId] };
};

const submitJD = async (): Promise<void> => {
  if (!jobDescriptions?.hasOwnProperty(jobDescriptionQValue.title))
  {
    let user2 = await updateJobDescriptions(jobDescriptionQValue);
    setprofileUser(user2);
  }
  setjobDescriptionQ(jobDescriptionQValue);
  NavigateToQBank(type.BOTH, track.JOB_DESCRIPTIONQ);
}


  const getTrack = (): string | null => {
    if (state.profileUser && state.profileUser.lastPath) {
      //console.log(props.user.lastPath);
      const parsedQuery1 = parseQuestionQuery(state.profileUser.lastPath);
      setParsedQuery(parsedQuery1!);
      return parsedQuery1["role"] !== undefined && parsedQuery1["role"] !== ""
        ? parsedQuery1["role"]
        : null;
    } else if (
      state.profileUser &&
      Object.keys(state.profileUser.intakeForm).length > 0 &&
      state.profileUser.intakeForm["interestedRoles"]!= undefined
    ) {
      setParsedQuery({});
      return (state.profileUser.intakeForm["interestedRoles"] as string[])[0]||DefaultRole; //default to software engineering if here
    }
    return null;
  }
  //console.log(props.user);<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#e77408"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.5 12.5L10.0089 14.0089C10.3526 14.3526 10.5245 14.5245 10.7198 14.5822C10.8914 14.6328 11.0749 14.6245 11.2412 14.5585C11.4305 14.4834 11.5861 14.2967 11.8973 13.9232L16 9M16.3287 4.75855C17.0676 4.77963 17.8001 5.07212 18.364 5.636C18.9278 6.19989 19.2203 6.9324 19.2414 7.67121C19.2623 8.40232 19.2727 8.76787 19.2942 8.85296C19.3401 9.0351 19.2867 8.90625 19.383 9.06752C19.428 9.14286 19.6792 9.40876 20.1814 9.94045C20.6889 10.4778 21 11.2026 21 12C21 12.7974 20.6889 13.5222 20.1814 14.0595C19.6792 14.5912 19.428 14.8571 19.383 14.9325C19.2867 15.0937 19.3401 14.9649 19.2942 15.147C19.2727 15.2321 19.2623 15.5977 19.2414 16.3288C19.2203 17.0676 18.9278 17.8001 18.364 18.364C17.8001 18.9279 17.0676 19.2204 16.3287 19.2414C15.5976 19.2623 15.2321 19.2727 15.147 19.2942C14.9649 19.3401 15.0937 19.2868 14.9325 19.3831C14.8571 19.4281 14.5912 19.6792 14.0595 20.1814C13.5222 20.6889 12.7974 21 12 21C11.2026 21 10.4778 20.6889 9.94047 20.1814C9.40874 19.6792 9.14287 19.4281 9.06753 19.3831C8.90626 19.2868 9.0351 19.3401 8.85296 19.2942C8.76788 19.2727 8.40225 19.2623 7.67121 19.2414C6.93238 19.2204 6.19986 18.9279 5.63597 18.364C5.07207 17.8001 4.77959 17.0676 4.75852 16.3287C4.73766 15.5976 4.72724 15.2321 4.70578 15.147C4.65985 14.9649 4.71322 15.0937 4.61691 14.9324C4.57192 14.8571 4.32082 14.5912 3.81862 14.0595C3.31113 13.5222 3 12.7974 3 12C3 11.2026 3.31113 10.4778 3.81862 9.94048C4.32082 9.40876 4.57192 9.14289 4.61691 9.06755C4.71322 8.90628 4.65985 9.03512 4.70578 8.85299C4.72724 8.7679 4.73766 8.40235 4.75852 7.67126C4.77959 6.93243 5.07207 6.1999 5.63597 5.636C6.19986 5.07211 6.93238 4.77963 7.67121 4.75855C8.40232 4.73769 8.76788 4.72727 8.85296 4.70581C9.0351 4.65988 8.90626 4.71325 9.06753 4.61694C9.14287 4.57195 9.40876 4.32082 9.94047 3.81863C10.4778 3.31113 11.2026 3 12 3C12.7974 3 13.5222 3.31114 14.0595 3.81864C14.5913 4.32084 14.8571 4.57194 14.9325 4.61693C15.0937 4.71324 14.9649 4.65988 15.147 4.70581C15.2321 4.72726 15.5976 4.73769 16.3287 4.75855Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
  const EmptyBadge = createSvgIcon(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_iconCarrier">
        <path d="M18.364 5.636C17.8001 5.07212 17.0676 4.77963 16.3287 4.75855C15.5976 4.73769 15.2321 4.72726 15.147 4.70581C14.9649 4.65988 15.0937 4.71324 14.9325 4.61693C14.8571 4.57194 14.5913 4.32084 14.0595 3.81864C13.5222 3.31114 12.7974 3 12 3C11.2026 3 10.4778 3.31113 9.94047 3.81863C9.40876 4.32082 9.14287 4.57195 9.06753 4.61694C8.90626 4.71325 9.0351 4.65988 8.85296 4.70581C8.76788 4.72727 8.40232 4.73769 7.67121 4.75855C6.93238 4.77963 6.19986 5.07211 5.63597 5.636C5.07207 6.1999 4.77959 6.93243 4.75852 7.67126C4.73766 8.40235 4.72724 8.7679 4.70578 8.85299C4.65985 9.03512 4.71322 8.90628 4.61691 9.06755C4.57192 9.14289 4.32082 9.40876 3.81862 9.94048C3.31113 10.4778 3 11.2026 3 12C3 12.7974 3.31113 13.5222 3.81862 14.0595C4.32082 14.5912 4.57192 14.8571 4.61691 14.9324C4.71322 15.0937 4.65985 14.9649 4.70578 15.147C4.72724 15.2321 4.73766 15.5976 4.75852 16.3287C4.77959 17.0676 5.07207 17.8001 5.63597 18.364C6.19986 18.9279 6.93238 19.2204 7.67121 19.2414C8.40225 19.2623 8.76788 19.2727 8.85296 19.2942C9.0351 19.3401 8.90626 19.2868 9.06753 19.3831C9.14287 19.4281 9.40874 19.6792 9.94047 20.1814C10.4778 20.6889 11.2026 21 12 21C12.7974 21 13.5222 20.6889 14.0595 20.1814C14.5912 19.6792 14.8571 19.4281 14.9325 19.3831C15.0937 19.2868 14.9649 19.3401 15.147 19.2942C15.2321 19.2727 15.5976 19.2623 16.3287 19.2414C17.0676 19.2204 17.8001 18.9279 18.364 18.364C18.9278 17.8001 19.2203 17.0676 19.2414 16.3288C19.2623 15.5977 19.2727 15.2321 19.2942 15.147C19.3401 14.9649 19.2867 15.0937 19.383 14.9325C19.428 14.8571 19.6792 14.5912 20.1814 14.0595C20.6889 13.5222 21 12.7974 21 12C21 11.2026 20.6889 10.4778 20.1814 9.94045C19.6792 9.40876 19.428 9.14286 19.383 9.06752C19.2867 8.90625 19.3401 9.0351 19.2942 8.85296C19.2727 8.76787 19.2623 8.40232 19.2414 7.67121C19.2203 6.9324 18.9278 6.19989 18.364 5.636Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>,
    'badgeEmpty'
  );

  const FilledBadge = createSvgIcon(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_iconCarrier">
        <path d="M8.5 12.5L10.0089 14.0089C10.3526 14.3526 10.5245 14.5245 10.7198 14.5822C10.8914 14.6328 11.0749 14.6245 11.2412 14.5585C11.4305 14.4834 11.5861 14.2967 11.8973 13.9232L16 9M16.3287 4.75855C17.0676 4.77963 17.8001 5.07212 18.364 5.636C18.9278 6.19989 19.2203 6.9324 19.2414 7.67121C19.2623 8.40232 19.2727 8.76787 19.2942 8.85296C19.3401 9.0351 19.2867 8.90625 19.383 9.06752C19.428 9.14286 19.6792 9.40876 20.1814 9.94045C20.6889 10.4778 21 11.2026 21 12C21 12.7974 20.6889 13.5222 20.1814 14.0595C19.6792 14.5912 19.428 14.8571 19.383 14.9325C19.2867 15.0937 19.3401 14.9649 19.2942 15.147C19.2727 15.2321 19.2623 15.5977 19.2414 16.3288C19.2203 17.0676 18.9278 17.8001 18.364 18.364C17.8001 18.9279 17.0676 19.2204 16.3287 19.2414C15.5976 19.2623 15.2321 19.2727 15.147 19.2942C14.9649 19.3401 15.0937 19.2868 14.9325 19.3831C14.8571 19.4281 14.5912 19.6792 14.0595 20.1814C13.5222 20.6889 12.7974 21 12 21C11.2026 21 10.4778 20.6889 9.94047 20.1814C9.40874 19.6792 9.14287 19.4281 9.06753 19.3831C8.90626 19.2868 9.0351 19.3401 8.85296 19.2942C8.76788 19.2727 8.40225 19.2623 7.67121 19.2414C6.93238 19.2204 6.19986 18.9279 5.63597 18.364C5.07207 17.8001 4.77959 17.0676 4.75852 16.3287C4.73766 15.5976 4.72724 15.2321 4.70578 15.147C4.65985 14.9649 4.71322 15.0937 4.61691 14.9324C4.57192 14.8571 4.32082 14.5912 3.81862 14.0595C3.31113 13.5222 3 12.7974 3 12C3 11.2026 3.31113 10.4778 3.81862 9.94048C4.32082 9.40876 4.57192 9.14289 4.61691 9.06755C4.71322 8.90628 4.65985 9.03512 4.70578 8.85299C4.72724 8.7679 4.73766 8.40235 4.75852 7.67126C4.77959 6.93243 5.07207 6.1999 5.63597 5.636C6.19986 5.07211 6.93238 4.77963 7.67121 4.75855C8.40232 4.73769 8.76788 4.72727 8.85296 4.70581C9.0351 4.65988 8.90626 4.71325 9.06753 4.61694C9.14287 4.57195 9.40876 4.32082 9.94047 3.81863C10.4778 3.31113 11.2026 3 12 3C12.7974 3 13.5222 3.31114 14.0595 3.81864C14.5913 4.32084 14.8571 4.57194 14.9325 4.61693C15.0937 4.71324 14.9649 4.65988 15.147 4.70581C15.2321 4.72726 15.5976 4.73769 16.3287 4.75855Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>,
    'badgeFilled'
  );

  const NetflixBadge = createSvgIcon(<svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_i_806_7888)">
    <path d="M64.4988 83.9852C64.6964 84.0644 66.596 84.8348 66.8687 84.946C66.8761 84.9487 66.8922 84.9549 66.9115 84.9629C66.943 84.9753 66.9305 84.97 66.9457 84.9762C66.9785 84.9896 66.9893 84.994 67.001 84.9985C67.0012 84.4016 67.0014 83.5173 67.0015 82.5717C67.0016 81.3618 67.0015 80.0781 67.0015 79.4403V5.00049H51.2891V46.6366C51.7699 47.9959 53.8044 53.7647 54.3252 55.2175C55.2981 57.9886 60.8353 73.6277 61.2779 74.8784C61.6748 76.0011 62.7801 79.1218 63.1314 80.1199C63.3368 80.6982 63.873 82.2105 64.158 83.0165C64.3807 83.6472 64.3606 83.5956 64.4988 83.9852Z" fill="#B11F24"/>
    </g>
    <g filter="url(#filter1_i_806_7888)">
    <path d="M25.5106 6.014C25.3129 5.93439 23.4134 5.16453 23.1407 5.0536C23.1333 5.05057 23.1172 5.04399 23.0979 5.03616C23.0664 5.02371 23.0788 5.02905 23.0637 5.02291C23.0309 5.00974 23.02 5.0052 23.0084 5.00049C23.0082 5.59767 23.0079 6.48193 23.0079 7.42757C23.0078 8.63698 23.0079 9.92111 23.0079 10.5592V84.999C29.2494 84.2491 32.3709 83.9573 38.7203 83.6682V43.3626C38.2395 42.0035 36.205 36.2344 35.6842 34.7816C34.7113 32.0109 29.1741 16.3718 28.7314 15.1207C28.3346 13.9981 27.2293 10.8776 26.878 9.87894C26.6726 9.30124 26.1363 7.78919 25.8514 6.98277C25.6287 6.35223 25.6488 6.404 25.5106 6.014Z" fill="#B11F24"/>
    </g>
    <path d="M38.7124 5H23L50.8228 83.6681C58.6416 83.8655 67.0057 84.9989 67.0057 84.9989L38.7124 5Z" fill="#ED1C24"/>
    <defs>
    <filter id="filter0_i_806_7888" x="51.2891" y="-0.999512" width="15.7109" height="85.998" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="-10"/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_806_7888"/>
    </filter>
    <filter id="filter1_i_806_7888" x="23.0078" y="5.00049" width="15.7109" height="85.9985" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="10"/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_806_7888"/>
    </filter>
    </defs>
    </svg>, "Netflix"
    );

  const AmazonBadge = createSvgIcon(<svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M74.0932 70.8556C41.0733 86.5701 20.5808 73.4223 7.46285 65.4365C6.65112 64.9332 5.27146 65.5542 6.46851 66.9291C10.8387 72.2281 25.1609 85 43.8555 85C62.563 85 73.6922 74.7925 75.0844 73.0118C76.4672 71.2463 75.4907 70.2723 74.0932 70.8556ZM83.3668 65.7343C82.48 64.5796 77.9749 64.3644 75.1396 64.7127C72.3 65.0509 68.0377 66.7864 68.4083 67.8284C68.5984 68.2187 68.9865 68.0436 70.9373 67.8682C72.8933 67.6731 78.3731 66.9815 79.5149 68.4741C80.662 69.9771 77.7672 77.1367 77.2385 78.2913C76.7276 79.446 77.4336 79.7438 78.3931 78.9747C79.3395 78.206 81.0527 76.2151 82.2024 73.3978C83.3442 70.5651 84.0407 66.6135 83.3668 65.7343Z" fill="#FF9900"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M51.8909 38.7904C51.8909 42.9136 51.9951 46.3522 49.911 50.0139C48.2289 52.9912 45.5643 54.8221 42.5872 54.8221C38.5232 54.8221 36.1565 51.7258 36.1565 47.1561C36.1565 38.1352 44.2392 36.498 51.8909 36.498V38.7904ZM62.5639 64.5872C61.8642 65.2122 60.852 65.2571 60.0631 64.8401C56.5501 61.9226 55.9248 60.5681 53.9897 57.7843C48.1843 63.7089 44.0758 65.4801 36.5436 65.4801C27.6419 65.4801 20.705 59.9873 20.705 48.9869C20.705 40.3981 25.3645 34.5479 31.9883 31.6901C37.7344 29.1592 45.7579 28.7127 51.8909 28.0134V26.6438C51.8909 24.128 52.0842 21.1509 50.6107 18.9778C49.3155 17.0277 46.8445 16.2238 44.671 16.2238C40.6371 16.2238 37.0347 18.2928 36.1565 22.5798C35.9776 23.5327 35.2782 24.4706 34.3256 24.5152L24.0542 23.4138C23.191 23.2199 22.2384 22.5205 22.4766 21.1955C24.8434 8.75142 36.0818 5 46.1445 5C51.2951 5 58.0233 6.3696 62.0873 10.2697C67.2379 15.0776 66.7465 21.4932 66.7465 28.4746V44.9678C66.7465 49.9248 68.8008 52.0979 70.7358 54.7775C71.4205 55.7301 71.5695 56.8766 70.706 57.5908C68.5476 59.3918 64.707 62.7413 62.5934 64.617L62.5639 64.5872Z" fill="#000008"/>
    <path d="M74.0932 70.8556C41.0733 86.5701 20.5808 73.4223 7.46285 65.4365C6.65112 64.9332 5.27146 65.5542 6.46851 66.9291C10.8387 72.2281 25.1609 85 43.8555 85C62.563 85 73.6922 74.7925 75.0844 73.0118C76.4672 71.2463 75.4907 70.2723 74.0932 70.8556ZM83.3668 65.7343C82.48 64.5796 77.9749 64.3644 75.1396 64.7127C72.3 65.0509 68.0377 66.7864 68.4083 67.8284C68.5984 68.2187 68.9865 68.0436 70.9373 67.8682C72.8933 67.6731 78.3731 66.9815 79.5149 68.4741C80.662 69.9771 77.7672 77.1367 77.2385 78.2913C76.7276 79.446 77.4336 79.7438 78.3931 78.9747C79.3395 78.206 81.0527 76.2151 82.2024 73.3978C83.3442 70.5651 84.0407 66.6135 83.3668 65.7343Z" fill="#FF9900"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M51.8909 38.7904C51.8909 42.9136 51.9951 46.3522 49.911 50.0139C48.2289 52.9912 45.5643 54.8221 42.5872 54.8221C38.5232 54.8221 36.1565 51.7258 36.1565 47.1561C36.1565 38.1352 44.2392 36.498 51.8909 36.498V38.7904ZM62.5639 64.5872C61.8642 65.2122 60.852 65.2571 60.0631 64.8401C56.5501 61.9226 55.9248 60.5681 53.9897 57.7843C48.1843 63.7089 44.0758 65.4801 36.5436 65.4801C27.6419 65.4801 20.705 59.9873 20.705 48.9869C20.705 40.3981 25.3645 34.5479 31.9883 31.6901C37.7344 29.1592 45.7579 28.7127 51.8909 28.0134V26.6438C51.8909 24.128 52.0842 21.1509 50.6107 18.9778C49.3155 17.0277 46.8445 16.2238 44.671 16.2238C40.6371 16.2238 37.0347 18.2928 36.1565 22.5798C35.9776 23.5327 35.2782 24.4706 34.3256 24.5152L24.0542 23.4138C23.191 23.2199 22.2384 22.5205 22.4766 21.1955C24.8434 8.75142 36.0818 5 46.1445 5C51.2951 5 58.0233 6.3696 62.0873 10.2697C67.2379 15.0776 66.7465 21.4932 66.7465 28.4746V44.9678C66.7465 49.9248 68.8008 52.0979 70.7358 54.7775C71.4205 55.7301 71.5695 56.8766 70.706 57.5908C68.5476 59.3918 64.707 62.7413 62.5934 64.617L62.5639 64.5872Z" fill="#000008"/>
    </svg>
    , "Amazon");
  const SpotifyBadge = createSvgIcon(<svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M68.6624 40.4609C55.7686 32.8036 34.5 32.0996 22.1913 35.8358C20.2148 36.4352 18.1245 35.3194 17.5256 33.3429C16.9266 31.3654 18.0414 29.2767 20.0194 28.6758C34.1489 24.3865 57.6376 25.2152 72.4813 34.0264C74.2591 35.0816 74.8423 37.3776 73.7886 39.1526C72.734 40.9304 70.436 41.5165 68.6624 40.4609ZM68.2402 51.8022C67.3355 53.2701 65.4163 53.7305 63.9503 52.8292C53.2007 46.2218 36.809 44.3079 24.0914 48.1678C22.4421 48.6665 20.7001 47.7365 20.1995 46.0905C19.7022 44.4411 20.6327 42.7025 22.2787 42.201C36.8071 37.7927 54.8677 39.9278 67.2142 47.5148C68.6801 48.4176 69.1415 50.3382 68.2402 51.8022ZM63.3456 62.6941C62.6268 63.873 61.0921 64.2422 59.9175 63.5238C50.5239 57.7829 38.701 56.4866 24.7773 59.6668C23.4356 59.9744 22.0986 59.1337 21.7925 57.792C21.4853 56.4507 22.3227 55.1133 23.6677 54.8071C38.9045 51.3241 51.975 52.823 62.5183 59.2655C63.6938 59.9835 64.064 61.5191 63.3456 62.6941ZM45.0008 5C22.9092 5 5 22.9086 5 44.9995C5 67.0928 22.9092 85 45.0008 85C67.0928 85 85.0011 67.0928 85.0011 44.9995C85.0011 22.9086 67.0928 5 45.0008 5Z" fill="#1ED760"/>
  </svg>, "Spotify")
  
  const MetaBadge = createSvgIcon(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><rect fill="#3d5a98" x="4.83" y="4.83" width="118.35" height="118.35" rx="6.53" ry="6.53"/><path fill="#fff" d="M86.48 123.17V77.34h15.38l2.3-17.86H86.48v-11.4c0-5.17 1.44-8.7 8.85-8.7h9.46v-16A126.56 126.56 0 0091 22.7c-13.62 0-23 8.3-23 23.61v13.17H52.62v17.86H68v45.83z"/></svg>, "Meta");
  const AppleBadge = createSvgIcon(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path d="M97.905 67.885c.174 18.8 16.494 25.057 16.674 25.137-.138.44-2.607 8.916-8.597 17.669-5.178 7.568-10.553 15.108-19.018 15.266-8.318.152-10.993-4.934-20.504-4.934-9.508 0-12.479 4.776-20.354 5.086-8.172.31-14.395-8.185-19.616-15.724C15.822 94.961 7.669 66.8 18.616 47.791c5.438-9.44 15.158-15.417 25.707-15.571 8.024-.153 15.598 5.398 20.503 5.398 4.902 0 14.106-6.676 23.782-5.696 4.051.169 15.421 1.636 22.722 12.324-.587.365-13.566 7.921-13.425 23.639M82.272 21.719c4.338-5.251 7.258-12.563 6.462-19.836-6.254.251-13.816 4.167-18.301 9.416-4.02 4.647-7.54 12.087-6.591 19.216 6.971.54 14.091-3.542 18.43-8.796"/></svg>, "Apple");
  const GoogleBadge = createSvgIcon(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path fill="#fff" d="M44.59 4.21a63.28 63.28 0 004.33 120.9 67.6 67.6 0 0032.36.35 57.13 57.13 0 0025.9-13.46 57.44 57.44 0 0016-26.26 74.33 74.33 0 001.61-33.58H65.27v24.69h34.47a29.72 29.72 0 01-12.66 19.52 36.16 36.16 0 01-13.93 5.5 41.29 41.29 0 01-15.1 0A37.16 37.16 0 0144 95.74a39.3 39.3 0 01-14.5-19.42 38.31 38.31 0 010-24.63 39.25 39.25 0 019.18-14.91A37.17 37.17 0 0176.13 27a34.28 34.28 0 0113.64 8q5.83-5.8 11.64-11.63c2-2.09 4.18-4.08 6.15-6.22A61.22 61.22 0 0087.2 4.59a64 64 0 00-42.61-.38z"/><path fill="#e33629" d="M44.59 4.21a64 64 0 0142.61.37 61.22 61.22 0 0120.35 12.62c-2 2.14-4.11 4.14-6.15 6.22Q95.58 29.23 89.77 35a34.28 34.28 0 00-13.64-8 37.17 37.17 0 00-37.46 9.74 39.25 39.25 0 00-9.18 14.91L8.76 35.6A63.53 63.53 0 0144.59 4.21z"/><path fill="#f8bd00" d="M3.26 51.5a62.93 62.93 0 015.5-15.9l20.73 16.09a38.31 38.31 0 000 24.63q-10.36 8-20.73 16.08a63.33 63.33 0 01-5.5-40.9z"/><path fill="#587dbd" d="M65.27 52.15h59.52a74.33 74.33 0 01-1.61 33.58 57.44 57.44 0 01-16 26.26c-6.69-5.22-13.41-10.4-20.1-15.62a29.72 29.72 0 0012.66-19.54H65.27c-.01-8.22 0-16.45 0-24.68z"/><path fill="#319f43" d="M8.75 92.4q10.37-8 20.73-16.08A39.3 39.3 0 0044 95.74a37.16 37.16 0 0014.08 6.08 41.29 41.29 0 0015.1 0 36.16 36.16 0 0013.93-5.5c6.69 5.22 13.41 10.4 20.1 15.62a57.13 57.13 0 01-25.9 13.47 67.6 67.6 0 01-32.36-.35 63 63 0 01-23-11.59A63.73 63.73 0 018.75 92.4z"/></svg>, "Google");

  return (
    <div className='full-nav'>
      <div className="dashboardScreen">
        <div className='dashboardContent'>
          <div className="flex-col w-[100%] items-start">
            <div className="flex-col items-start">
              <p className="text-customBlack text-lg mb-3">{`Welcome ${state.profileUser ? `home, ${state.profileUser.name.split(' ')[0]}` : ''}`}</p>
              <div className="flex justify-between w-[100%]">
                <p className="font-bold text-left text-grayBlue text-5xl">Dashboard{state.role ? `: ${capitalizeFirstLetter(state.role)}` : ''}</p>
                {state.profileUser && <div className="landingIcons flex-col items-center ml-4">
                  {state.profileUser.streak !== undefined && state.profileUser.streak > 0 && <FilledBadge 
                     sx={{ 
                      fill:'none',
                      color: '#e77408',
                      width: '60px',
                      height: '60px',
                      stroke: '#e77408'  // This sets the stroke color
                    }}  />}
                  {state.profileUser.streak === undefined || state.profileUser.streak <= 0 &&
                    <EmptyBadge 
                      sx={{ 
                        fill:'none',
                        color: '#e77408',
                        width: '60px',
                        height: '60px',
                        stroke: '#e77408'  // This sets the stroke color
                      }} 
                    />
                  }

                  <p className="text-grayBlue">{state.profileUser.streak !== undefined && state.profileUser.streak > 0 ? `${state.profileUser.streak} day streak` : '0 day streak'}</p>
                </div>
                }
              </div>
              <p className="text-customBlack text-lg mt-4 w-[65%] text-left">Get started to landing your dream role by practicing core concepts and experience-related questions with our mock interview platform.</p>
              <div className="mt-4 flex items-start">
                <img src={buddy} className="buddy mt-5" alt="buddy" />
                <div className="flex-col gap-3 shadow-sm mb-5 ml-2 p-3 bg-white w-[65%]">
                  {
                    <div className='text-left w-[100%]'>
                      <div className=""><p className='mr-5 text-grayBlue text-2xl mb-1' >Hi, I'm Buddy</p>
                        <p className='text-customBlack mb-2'>I'm here to encourage you and help guide you on your journey!</p>
                        {(!state.profileUser || lastSavedSessionForRole.length == 0 ) && <div data-custom-user-click="GetStarted"  className='justify-self-center flex justify-center item-center px-3 py-2 text-white cursor-pointer hover:bg-orangeButton-hover font-[300] bg-orangeButton rounded-md shadow-sm' onClick={() => state.profileUser ? NavigateToQBank(type.BOTH, track.PACK) : auth0.loginWithPopup()}><p>Get Started</p></div>}
                       
                    {lastSavedSessionForRole.length > 0  && <div className='flex justify-between gap-2'>
                        <div className='px-3 py-2 cursor-pointer text-white font-[300] hover:bg-orangeButton-hover bg-orangeButton rounded-md shadow-sm' onClick={() => resumeSesh()}><p>Continue Saved Session</p></div>
                        <div className='px-3 py-2 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={() => NavigateToQBank(type.BOTH, track.PACK)}><p>Start New Session</p></div>
                </div>
        }
                      </div>
                    </div>}
                  {/* {
                    !state.profileUser?.lastInterviewCompleteDate &&
                    <div className='text-left w-[100%]'>
                      <div className=""><p className='mr-5 text-grayBlue text-2xl mb-1' >Practice Makes Perfect!</p>
                    </div>
                  </div>
                  } */}
                </div>
              </div>
              
              
              {state.role !== null && state.role !== "" &&
              <>
              <div className="flex-col items-start">
               <p className='text-2xl text-left font-bold'>Get Started: {capitalizeFirstLetter(state.role)} Track</p>
              </div>
              <div className="flex-col mb-5 p-1 w-[100%]">
                <div className="flex-col w-[100%] my-4 ">
                  <div className="flex justify-start flex-wrap gap-y-2">
                    {/* Fit three rectangles per row */}
                    <div data-custom-user-click="EssentialQs" onClick={()=>NavigateToQBank(type.ESSENTIAL, track.PACK)} className="w-[31%] bg-whiteButton hover:bg-whiteButton-hover rounded-lg shadow-md  mx-2 p-2  flex text-grayBlue cursor-pointer">
                      <div className="grad p-2 mr-3 flex self-center">
                        <AllInclusiveIcon />
                      </div>
                      <div className="flex-col justify-start items-start text-left" >
                        <p className="mb-2 text-xs">Core Interviewing Skills</p>
                        <p className='lg:text-xl text-xs sm:text-xs md:text-lg font-semibold'>Essential Behavioral</p>
                      </div>
                    </div>
                    <div data-custom-user-click="technicalQs" onClick={()=>NavigateToQBank(type.TECHNICAL, track.PACK)} className="w-[31%] rounded-lg shadow-md bg-whiteButton hover:bg-whiteButton-hover mx-2 p-2  flex text-grayBlue cursor-pointer">
                      <div className="grad p-2 mr-3 flex self-center">
                        <AllInclusiveIcon />
                      </div>
                      <div className="flex-col justify-around items-start text-left" >
                        <p className="mb-2 text-xs">{capitalizeFirstLetter(state.role)}</p>
                        <p className='lg:text-xl text-xs sm:text-xs md:text-lg font-semibold'>Technical</p>
                      </div>
                    </div>
                    <div data-custom-user-click="behavioralQs" onClick={()=>NavigateToQBank(type.BEHAVIORAL, track.PACK)} className="w-[31%] bg-whiteButton hover:bg-whiteButton-hover rounded-lg shadow-md mx-2 p-2  flex text-grayBlue cursor-pointer">
                      <div className="grad p-2 mr-3 flex self-center">
                        <AllInclusiveIcon />
                      </div>
                      <div className="flex-col justify-around items-start text-left" >
                        <p className="mb-2 text-xs">{capitalizeFirstLetter(state.role)}</p>
                        <p className='lg:text-xl text-xs sm:text-xs md:text-lg font-semibold'>Behavioral</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-col items-start">
               <p className='text-2xl text-left font-bold'>More Question Types: {capitalizeFirstLetter(state.role)} Track</p> 
              </div>
              <div className="flex-col p-2 w-[100%]">
                <div className="flex-col w-[100%] my-4">
                  <div className="flex justify-start flex-wrap">
                    {/* Fit three rectangles per row */}
                    <div className="px-3 w-[48%] rounded-lg shadow-md bg-white mx-1 p-2 flex-col justify-around text-grayBlue cursor-pointer">
                      <div className="p-2 flex items-start justify-between">
                        <p className='text-xl'>Job Description Based Questions</p>
                        {jobDescriptionQValue.description !== "" && jobDescriptionQValue.title !=="" && <div data-custom-user-click="submitJd" className='px-3 py-2 ml-3  text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={()=>submitJD()}><p>Go</p></div>}
                      </div>
                      <div className='flex justify-start pl-3' >
                        <p className="my-3 text-sm font-thin text-left text-customBlack">If you're preparing for a specific role, first type in a name for your job description, press enter, then copy over a job description and we'll create an custom practice for you.</p>
                      </div>
                        <DropdownWithInput handleChange={(e) => handleJDTitle(e)}
                          options={JDOptions}/>
                        <br/>
                         <TextField
                             id="outlined-textarea"
                             placeholder={sampleJD}
                             disabled={readOnly}
                             multiline  
                             minRows={3} 
                             maxRows={3}   
                             value={jobDescriptionQValue.description}     
                             onChange={(e) => setjobDescriptionQValue({ ...jobDescriptionQValue, description: e.target.value })}
                            name="jobDescription"
                            fullWidth
                        />
                    </div>
                    <div className="px-3 w-[48%] rounded-lg shadow-md bg-white mx-1 p-2 flex-col justify-around text-grayBlue cursor-pointer">
                      <div className="p-2 flex  items-start justify-between">
                        <p className='text-xl'>Create My Own Question</p>
                        {state.customQ !== "" && <div data-custom-user-click="submitCustomQ"  className='px-3 py-2 ml-3 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={()=>NavigateForCustom()}><p>Go</p></div>}
                      </div>
                      <div className='flex justify-start pl-3'>
                        <p className="my-2 text-sm text-left font-thin text-customBlack">If there is a question you want to practice, write it in and get started practicing.</p>
                      </div>
                      <TextField
                             id="outlined-textarea"
                             label="Enter your question"
                             multiline  
                             minRows={3}         
                            name="customQuestion"
                            onChange={(e)=>setcustomQ(e.target.value)}
                            fullWidth
                        />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-col mb-5 p-2 w-[100%]">
                <div className="flex-col w-[100%] my-4">
                  <div className="flex justify-start flex-wrap">
                    {/* Fit three rectangles per row */}
                    <div className="px-3 w-[48%] rounded-lg shadow-md bg-white mx-1 p-2 flex-col justify-around text-grayBlue cursor-pointer">
                    
                      <div data-custom-user-click="submitResumeQs" className="p-2 flex  items-start justify-between">
                        <p className='text-xl'>Resume Based Questions</p>
                        {state.profileUser?.resumetext !== "" && <div className='px-3 py-2 ml-3 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={()=>{
                          if (!hasPremSub(state.profileUser!))
                         {
                          setshowPaymentModal(true);
                        }
                        else{
                          NavigateToQBank(type.BEHAVIORAL, track.RESUME_BASED,)
                        }
                        }}><p>Go</p></div>}
                       </div>
                        {state.profileUser?.resumetext === "" && <>
                        <div className="p-2 mr-3 flex items-center">
                          <ErrorOutline
                          sx={{color:'red'}} />
                          <p className="my-2 text-sm font-thin text-customBlack"><span className="font-bold">Upload Your Resume</span> to practice questions specific to your experiences.</p>
                          </div>
                          <UploadFile
                            handleDefaultRemove={()=>setResume({ file: "", text: "" })}
                            contentChange={()=>setResume({ file: "", text: "" })}
                            handleFunc={(t: string, f: string, e?:string) => {setResume({ file: f, text: t });}}
                          />
                          </>
                        }
                        {state.profileUser?.resumetext !== "" &&
                           <div className="p-2 mr-3 flex-col items-center justify-center">
                           <TaskAltOutlined
                           sx={{color:'green'}} />
                           <p className="my-2 text-md font-bold text-black">Your Resume is on File!</p>
                           </div>
                        }
                        <p  className="my-2 text-sm font-thin text-left text-customBlack">Learn how to tackle resume questions and stand out in your interviews. Go to settings to update your resume.</p>
                        
                    </div>
                    <div className="px-3 w-[48%] rounded-lg shadow-md bg-white mx-1 p-2 flex-col justify-around text-grayBlue cursor-pointer">
                      <div className="p-2 flex items-start justify-between">
                        <p className='text-xl'>Company Questions</p>
                        {domainValue !== "" && <div data-custom-user-click="submitCompanyQs"  className='px-3 py-2 ml-3 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={()=>NavigateToQBank(type.BOTH, track.COMPANY, domainValue)}><p>Go</p></div>}
                      </div>
                      <div >
                        <p className="mt-2 mb-4 text-sm text-left font-thin flex justify-start pl-3 text-customBlack">Try practicing interview questions from a specific company.</p>
                      </div>
                      <div className="pl-3 mb-3">
                      <SearchBarWithIcon options={companyOptions.map(x=>x.label)}
                        editable={false}
                        handleChange={(x)=>setDomainValue(x.toLowerCase())}/>
                      </div>
                      <div className="flex gap-1 justify-around w-[100%] px-2"> 
                        <div onClick={()=>NavigateToQBank(type.BOTH, track.COMPANY, "amazon.com inc.")} className='w-[20%] bg-whiteButton hover:bg-whiteButton-hover flex-col'>
                        <AmazonBadge 
                          sx={{ 
                            width: '100%',
                          }} 
                        />
                        <p className='text-xs'>Amazon</p>
                        </div>
                        <div onClick={()=>NavigateToQBank(type.BOTH, track.COMPANY, "alphabet inc. (google)")} className='w-[20%] bg-whiteButton hover:bg-whiteButton-hover flex-col'>
                        <GoogleBadge 
                          sx={{ 
                            width: '100%',
                          }} 
                        />
                        <p className='text-xs'>Google</p>
                        </div>
                        <div onClick={()=>NavigateToQBank(type.BOTH, track.COMPANY, "spotify technology s.a.")} className='w-[20%] bg-whiteButton hover:bg-whiteButton-hover flex-col'>
                        <AppleBadge 
                          sx={{ 
                            width: '100%',
                          }} 
                        />
                        <p className='text-xs'>Apple</p>
                        </div>
                        <div onClick={()=>NavigateToQBank(type.BOTH, track.COMPANY, "spotify technology s.a.")} className='w-[20%] bg-whiteButton hover:bg-whiteButton-hover flex-col'>
                        <SpotifyBadge 
                          sx={{ 
                            width: '100%',
                          }} 
                        />
                        <p className='text-xs'>Spotify</p>
                        </div>
                        <div onClick={()=>NavigateToQBank(type.BOTH, track.COMPANY, "netflix, inc")} className='w-[20%] bg-whiteButton hover:bg-whiteButton-hover flex-col'>
                        <NetflixBadge 
                          sx={{ 
                            width: '100%',
                          }} 
                        />
                        <p className='text-xs'>Netflix</p>
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
              </>}
              {state.profileUser &&
              <>
              <div className="flex-col items-start">
               <p className='text-2xl text-left font-bold'>See More Tracks</p> 
              </div>
              <div className="flex-col mb-5 p-2 pr-4 w-[100%]">
                <div className="flex-col w-[100%] my-4">
                  <div className="flex justify-start flex-wrap">
                    {/* Fit three rectangles per row */}
                    <div className="w-[100%] rounded-lg shadow-md  bg-white mx-2 p-2  flex-col text-customBlack cursor-pointer">
                      <div className='flex justify-between w-[100%]'>
                        <SearchBarWithIcon options={roles}
                        editable={true}
                        handleChange={(role)=>setRoleValue(role.toLowerCase())}/>
                        {roleValue !== "" && <div data-custom-user-click="SubmitCustomRole" className='px-3 py-2 ml-3 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={()=>setrole(roleValue.toLowerCase())}><p>Go</p></div>}
                      </div>
                      <div className="flex-col justify-start items-start text-left" >
                        <p className="my-2 text-xs">Select from one of the predefined roles below or create a custom role to jumpstart your journey that's tailored to your unique needs.</p>
                      </div>
                      <RoleBadges />
                    </div>
                  </div>
                </div>
              </div>
              </>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;